export class CheckPayment {
    public id: number;
    public amount: number;
    public number: string;
    public date: Date;
    public source: string;
    
    constructor() {
      this.source = 'CHEQUE';
    }
  
  }  